module.exports = __webpack_public_path__ + "static/media/location-gris_old.72a5de14.svg";